module.exports = __webpack_public_path__ + "assets/img/29_261.b8af4784.jpg";